"use client";

import React, { useEffect } from "react";
import complete from "../assets/images/application.png";
import { Button } from "./ui/button";
import { Lock } from "lucide-react";

const InvestComplete = ({ onDone }) => {
  return (
    <>
      <div className="w-full max-w-xl p-12 flex flex-col items-center text-center">
        <img
          src={complete}
          alt="Application Success"
          width={150}
          height={150}
          className="mb-6"
        />

        <h2 className="text-2xl font-bold text-purple-700 mb-4">
          We're reviewing your application
        </h2>
        <p className="text-lg font-normal text-gray-600 mb-10">
          This normally takes between 12 - 24 hours. We'll notify you as soon as
          we're done.
        </p>

        <Button
          onClick={onDone}
          className="w-1/2 py-3 bg-gradient-to-tr from-purple-500 to-rose-500 text-white rounded-full font-bold h-12"
        >
          Done
        </Button>

        <div className="flex items-center justify-center gap-1 text-sm text-gray-500 mt-6">
          <Lock size={12} />
          <p>Secured by 80Eight</p>
        </div>
      </div>
    </>
  );
};

export default InvestComplete;
